import AppLogo from "@/components/AppLogo";
import GreenBackgroundShape from "@/components/ui/GreenBackgroundShape";
import { AccountBalanceDisplay } from "@/components/ui/accountBalanceDisplay/accountBalanceDisplay";
import { Button } from "@/components/ui/button/button";
import { InfoIcon, TransferIcon, TransferOutIcon } from "@/components/ui/icons";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { useAuth } from "@/context/auth-context";
import { useLoaderData, useNavigate } from "@tanstack/react-router";

const HomeHeader = () => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const { name } = useLoaderData({ from: "__root__" });

	return (
		<div className="relative inset-0 w-full text-white bg-cover bg-bottom bg-no-repeat ">
			<GreenBackgroundShape shapeType="sharp">
				<div className="flex items-center justify-center mb-4 relative z-10">
					<AppLogo theme="light" />
				</div>

				<div className="space-y-1 text-center relative z-10 mt-10">
					<h1 className="font-sans text-4xl font-bold">
						Welcome,{" "}
						<span className="capitalize">{user.first_name?.toLowerCase()}</span>
					</h1>
					<div className="flex items-center justify-center">
						<AccountBalanceDisplay className="font-sans text-3xl mt-2 font-bold" />
					</div>
					<div className="flex items-center justify-center">
						<div className="flex items-center justify-center gap-1 mt-1 text-sm text-white/80">
							Available balance
							<Popover>
								<PopoverTrigger>
									<InfoIcon className="w-6 h-6" />
								</PopoverTrigger>
								<PopoverContent align="center" className="">
									<div className="max-w-xs p-4 text-sm text-gray-800">
										The total amount in your {name} account available for
										transfers and transactions.
									</div>
								</PopoverContent>
							</Popover>
						</div>
					</div>
					<div className="flex items-center justify-center gap-2 pt-2">
						<Button
							variant="secondary"
							size={"md"}
							onClick={() =>
								navigate({
									to: "/main/deposit",
								})
							}
						>
							Add Funds
							<TransferIcon className="w-4 h-4 ml-1" />
						</Button>
						<Button
							size="md"
							data-testid="transfer-out-button"
							className="text-darkButtonText bg-primary-500"
							onClick={() =>
								navigate({
									to: "/main/withdraw",
								})
							}
						>
							Transfer Funds
							<TransferOutIcon className="w-4 h-4" />
						</Button>
					</div>
				</div>
			</GreenBackgroundShape>
		</div>
	);
};

export default HomeHeader;
